<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted() {
        let width = document.getELe
        document.addEventListener('resize', this.resize)
    },
    beforeDestroy() {
        document.removeEventListener('resize', this.resize)
    },
    methods: {
        resize(e) {}
    },
    created() {
      this.$store.dispatch('doGetCurrencyList')
    }
}
</script>

<style lang="less">
.size {
    width: 100%;
    height: 100%;
}
html,
body {
    .size;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
#app {
    .size;
}
.ivu-table-cell {
    padding: 5px !important;
}

// iview 公共样式
.ivu-modal-header {
    line-height: 30px !important;
    font-size: 16px;
    text-align: center;
    color: #1c2438;
}
// 修复 iview message 组件BUG
// 多个弹层时 z-index 过低不显示
.ivu-message {
    z-index: 9999 !important;
}
.ivu-table {
    font-size: 12px !important;
}

#l-data-record-mulsel {
    .ivu-select-selection {
        overflow: hidden !important;
        max-height: 32px !important;
    }
}
.ivu-input {
    font-size: 12px !important;
}
.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 12px !important;
}
.ivu-select-input {
    font-size: 12px !important;
}
.ivu-form .ivu-form-item-label {
    font-size: 12px !important;
}

.ivu-table-cell-tree {
    width: 22px !important;
    height: 22px !important;
    & > .ivu-icon.ivu-icon-ios-add::before {
        font-size: 18px !important;
    }
    & > .ivu-icon-ios-remove::before {
        font-size: 18px !important;
    }
}
.ivu-table td,
.ivu-table th {
    height: 45px !important;
}
.user-table-check td {
    background-color: #ebf7ff !important;
}

.table-padding {
    .ivu-table-body {
        padding-bottom: 200px !important;
    }
}
.manyTable .ivu-table-header {
    display: none;
}

.manyTable {
    .ivu-table-default .ivu-table-overflowX {
        overflow-x: hidden;
    }
}
// .ivu-table-cell-tree.ivu-table-cell-tree-empty {
//   display: none !important;
// }
// .ivu-table-cell-tree-level {
//   display: none !important;
// }
#game-lib-time .ivu-picker-panel-body {
    width: 56px !important;
}
#game-lib-time .ivu-time-picker-cells.ivu-time-picker-cells-with-seconds {
    & > div:not(:first-of-type) {
        display: none !important;
    }
}
#game-lib-time .ivu-select-dropdown {
    left: 0 !important;
}
.antiBrush input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
}
.ivu-spin.ivu-spin-default.ivu-spin-fix.ivu-spin-show-text.ivu-spin-fullscreen {
    background-color: rgba(0, 0, 0, 0.4);
}
</style>
